import { z } from 'zod';
import { CATEGORIES, NODE_TYPES, LIMITS } from '../constants.js';
import { uuidSchema, colorHexSchema } from './primitives.js';

// Posição no canvas — gravada como jsonb em `documents.position`.
export const positionSchema = z.object({
  x: z.number().finite(),
  y: z.number().finite(),
  size: z.number().min(20).max(2000).default(120),
  locked: z.boolean().default(false),
});
export type Position = z.infer<typeof positionSchema>;

// Conteúdo ProseMirror — schema mínimo. Tiptap valida o resto no front.
export const proseMirrorNodeSchema: z.ZodTypeAny = z.lazy(() =>
  z.object({
    type: z.string(),
    attrs: z.record(z.any()).optional(),
    content: z.array(proseMirrorNodeSchema).optional(),
    marks: z.array(z.object({ type: z.string(), attrs: z.record(z.any()).optional() })).optional(),
    text: z.string().optional(),
  }),
);

export const documentContentObjectSchema = z.object({
  type: z.literal('doc'),
  content: z.array(proseMirrorNodeSchema).optional(),
});
export type DocumentContentObject = z.infer<typeof documentContentObjectSchema>;

export const documentContentSchema = z.union([documentContentObjectSchema, z.string()]);
export type DocumentContent = z.infer<typeof documentContentSchema>;

export const createDocumentInput = z.object({
  id: uuidSchema.optional(),
  workspaceId: uuidSchema,
  parentId: uuidSchema.nullable().optional(),
  title: z.string().min(1).max(LIMITS.MAX_DOCUMENT_TITLE_LEN),
  icon: z.string().max(64).nullable().optional(),
  color: colorHexSchema.nullable().optional(),
  category: z.enum(CATEGORIES).default('idea'),
  type: z.enum(NODE_TYPES).default('idea'),
  isChildPage: z.boolean().default(false),
  content: documentContentSchema.nullable().optional(),
  position: positionSchema.optional(),
});
export type CreateDocumentInput = z.infer<typeof createDocumentInput>;

export const updateDocumentInput = createDocumentInput
  .partial()
  .omit({ workspaceId: true });
export type UpdateDocumentInput = z.infer<typeof updateDocumentInput>;

export const linkTypeSchema = z.enum(['synapse', 'wiki']);
export const createLinkInput = z.object({
  id: uuidSchema.optional(),
  workspaceId: uuidSchema,
  sourceId: uuidSchema,
  targetId: uuidSchema,
  type: linkTypeSchema.default('synapse'),
  strength: z.number().min(0).max(10).default(1),
});
export type CreateLinkInput = z.infer<typeof createLinkInput>;
